import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import NumberInput from "@/components/inputs/number.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {computed, PropType} from "vue"
  import {OrderLine} from "@/endpoints/rutsolve/gql/generated/graphql"
  import EnumerationPicker from "@/components/selectors/enumeration.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'order_line',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Object as PropType<OrderLine>
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  const value = _useModel(__props, "value")

  const grossUnitPrice = computed({
    get() {
      if (!value.value || !value.value.unitPrice) {
        return null
      } else {
        return value.value.unitPrice.gross
      }
    }, set(input: number) {
      if (!value.value || !value.value.unitPrice) {
        value.value.unitPrice = {}
      }
      value.value.unitPrice.gross = input
    }
  })

  const netUnitPrice = computed({
    get() {
      if (!value.value || !value.value.unitPrice) {
        return null
      } else {
        return value.value.unitPrice.net
      }
    }, set(input: number) {
      if (!value.value || !value.value.unitPrice) {
        value.value.unitPrice = {}
      }
      value.value.unitPrice.net = input
    }
  })

  function updateGrossUnitPrice() {
    if (!value.value.unitPrice || !value.value.unitPrice.net || value.value.unitPrice.net == 0) {
      value.value.unitPrice.gross = 0
      return
    }
    if (!value.value.vatRate || value.value.vatRate == 0) {
      value.value.unitPrice.gross = value.value.unitPrice.net
      return
    }
    const cent = 100
    const vatRatio = (value.value.vatRate + cent) / cent
    value.value.unitPrice.gross = value.value.unitPrice.net * vatRatio
  }

  function updateNetUnitPrice() {
    if (!value.value.unitPrice || !value.value.unitPrice.gross || value.value.unitPrice.gross == 0) {
      value.value.unitPrice.net = 0
      return
    }
    if (!value.value.vatRate || value.value.vatRate == 0) {
      value.value.unitPrice.net = value.value.unitPrice.gross
      return
    }
    const cent = 100
    const vatRatio = (value.value.vatRate + cent) / cent
    value.value.unitPrice.net = value.value.unitPrice.gross / vatRatio
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (value.value)
    ? (_openBlock(), _createBlock(_component_scoped, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            value: value.value.unit,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value.value.unit) = $event)),
            title: "Unit",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(NumberInput, {
            value: value.value.amount,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((value.value.amount) = $event)),
            title: "Amount",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.description,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((value.value.description) = $event)),
            title: "Description",
            readOnly: __props.readOnly,
            multiline: ""
          }, null, 8, ["value", "readOnly"]),
          _createVNode(NumberInput, {
            value: grossUnitPrice.value,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((grossUnitPrice).value = $event)),
            title: "Gross Unit Price",
            readOnly: __props.readOnly,
            onInput: _cache[4] || (_cache[4] = ($event: any) => (updateNetUnitPrice()))
          }, null, 8, ["value", "readOnly"]),
          _createVNode(NumberInput, {
            value: netUnitPrice.value,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((netUnitPrice).value = $event)),
            title: "Net Unit Price",
            readOnly: __props.readOnly,
            onInput: _cache[6] || (_cache[6] = ($event: any) => (updateGrossUnitPrice()))
          }, null, 8, ["value", "readOnly"]),
          _createVNode(NumberInput, {
            value: value.value.vatRate,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((value.value.vatRate) = $event)),
            title: "VAT Rate",
            readOnly: __props.readOnly,
            onInput: _cache[8] || (_cache[8] = ($event: any) => (updateGrossUnitPrice()))
          }, null, 8, ["value", "readOnly"]),
          _createVNode(EnumerationPicker, {
            selection: value.value.discountType,
            "onUpdate:selection": _cache[9] || (_cache[9] = ($event: any) => ((value.value.discountType) = $event)),
            options: ['FIXED', 'RATE', 'SUBTRACTION'],
            readOnly: __props.readOnly,
            title: "Discount Type"
          }, null, 8, ["selection", "readOnly"]),
          _createVNode(NumberInput, {
            value: value.value.discountValue,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((value.value.discountValue) = $event)),
            title: "Discount Value",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})